/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from 'antd';
import React, { useEffect } from 'react';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import { InputProps } from './FormInput.component';

const CommonInput = ({
    suffix,
    prefix,
    style,
    fraction,
    maximumFractionDigits = 1,
    callback,
    subtract,
    type = 'text',
    formatNumber = true,
    name,
    placeholder = PLACEHOLDER.TEXT,
    value,
    onChange,
    onValidateError,
    onlyRomanji = false,
    currentForm,
    rules = [],
    customFormat,
    ...props
}: InputProps) => {
    const [initFormat, setInitFormat] = React.useState<boolean>(true);

    const getNumberProps = () => {
        if (customFormat) {
            const prop: any = {};
            if (onlyRomanji) {
                prop.onKeyPress = commonHelpers.typeRomanji;
            }
            if (type === 'postcode') {
                prop.onKeyPress = commonHelpers.typeInteger;
            }
            return prop;
        }
        if (type === 'number') {
            return {
                onKeyPress: fraction
                    ? !subtract
                        ? commonHelpers.typeFraction
                        : commonHelpers.typeFractionSubtract
                    : !subtract
                      ? commonHelpers.typeInteger
                      : commonHelpers.typeIntegerSubtract,
                type: 'tel',
            };
        } else if (type === 'phone') {
            return {
                onKeyPress: commonHelpers.typePhoneNumber,
                type: 'tel',
            };
        }
        if (onlyRomanji) {
            return {
                onKeyPress: commonHelpers.typeRomanji,
            };
        }
        return {};
    };

    useEffect(() => {
        if (currentForm && onValidateError) {
            currentForm
                .validateFields([name || ''], {
                    validateOnly: currentForm.getFieldError(name || '').length <= 0,
                })
                .then(() => {
                    onValidateError(false);
                })
                .catch((err) => {
                    onValidateError(err.errorFields.length > 0);
                });
        }
    }, [rules]);

    useEffect(() => {
        if (value && initFormat) {
            const val = formatInput(value);
            onChange && onChange(val);
            setInitFormat(false);
        }
    }, [initFormat, value]);

    const endWithDot = (val: string) => {
        return fraction && val.indexOf('.') == val.length - 1;
    };

    const formatData = (value: any) => {
        let val = value;
        if (!val) return val;
        if (formatNumber) {
            if (customFormat) {
                val = commonHelpers.getOriginStringWithPattern(customFormat, val);
                val = commonHelpers.formatStringWithPattern(customFormat, val);
            } else if (type === 'number') {
                if (fraction && val.includes('.')) {
                    const arr = val.split('.');
                    const dot = endWithDot(val) ? '.' : '';
                    val = commonHelpers.formatNumberMoney(Number(arr[0]));
                    const fractionVal = arr[1] ?? '';
                    if (fractionVal) {
                        if (fractionVal.length > maximumFractionDigits) {
                            val = val + '.' + fractionVal.substring(0, maximumFractionDigits);
                        } else {
                            val = val + '.' + fractionVal;
                        }
                    } else {
                        val = val + dot;
                    }
                } else {
                    val = commonHelpers.formatNumberMoney(Number(val), 0);
                }
            }
        }
        return val;
    };

    const formatInput = (value?: any) => {
        if (!value) return value;
        let val = onlyRomanji ? commonHelpers.changeRomanji(value) : value;
        if (!val) return val;
        if (customFormat || type === 'phone' || type === 'number' || type === 'postcode') {
            // convert number full size to halft size
            val = commonHelpers.toASCII((val ?? '') + '');
            val = commonHelpers.toNumberOnly(val);
            //when prevent input text
            val = formatData(val);
        }
        // cut string
        if (props.maxLength && val.length > props.maxLength) {
            val = val.substring(0, props.maxLength);
        }
        return val;
    };

    return (
        <Input
            {...props}
            {...{ style, value }}
            autoComplete={'off'}
            suffix={suffix}
            prefix={prefix}
            placeholder={placeholder}
            onBlur={(e: any) => {
                const val = e.target.value;
                if (val?.trim) {
                    onChange && onChange(val?.trim());
                    callback && callback(val?.trim());
                }
                props.onBlur && props.onBlur(e);
            }}
            onChange={(e: any) => {
                const val = formatInput(e.target.value);
                onChange && onChange(val);
                callback && callback(val);
            }}
            {...getNumberProps()}
        />
    );
};

export default CommonInput;
